@use "@fukuri-admins/ui/layout" as *;

.titleArea {
  display: flex;
  align-items: center;
  gap: spacing("8");
}

.newsTitle {
  color: text("High");

  @include typography("Jp/20_W6");
}

.viewRateRow {
  display: flex;
  align-items: flex-start;
  gap: spacing("16");
}

// 上部ページタブ（記事 / 閲覧率）
.pageTabList {
  display: flex;
  border-bottom: 1px solid border("Tertiary");
}

.pageTab {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: spacing("12") spacing("16");
  min-width: 64px;
  color: text("High");
  background: transparent;
  border: none;
  cursor: pointer;

  @include typography("Jp/14_W3");
}

.activePageTab {
  @extend .pageTab;

  font-weight: 600;
  border-bottom: 2px solid border("Gray_Darken");
}

// 記事タブのコンテンツレイアウト
.articleContent {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
}

// 記事タブ：右カラム（編集ボタン）
.articleRight {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

// ラベル + テキストのフィールドブロック
.articleField {
  display: flex;
  flex-direction: column;
  gap: spacing("4");
  width: 466px;
}

// フィールドラベル
.fieldLabel {
  color: text("High");

  @include typography("Jp/14_W6");
}

// フィールド値（通常）
.fieldValue {
  color: text("High");

  @include typography("Jp/14_W3");
}

// フィールド値（改行対応：本文）
.fieldValuePreLine {
  white-space: pre-line;
  color: text("High");

  @include typography("Jp/14_W3");
}

// メインビジュアル画像
.mainImage {
  width: 400px;
  height: 233px;
  object-fit: cover;
}

// ファイルリスト
.fileList {
  display: flex;
  flex-direction: column;
  gap: spacing("8");
}

// ファイルリンク
.fileItem {
  color: text("High");
  text-decoration: none;

  @include typography("Jp/12_W3");

  &:hover {
    text-decoration: underline;
  }
}

.tabChipGroup {
  display: flex;
  gap: spacing('8');
}

.viewRateEmpty {
  display: flex;
  flex: 1;
  color: text("Low");

  @include typography("Jp/16_W3");

  > span {
    margin: auto;
  }
}
